import React from 'react';
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

import css from './TitleMenuOrders.module.css';
import {getTitleMenuOrders} from "../../../helpers";


const TitleMenuOrders = () => {
    const {t} = useTranslation();
    const listTitleMenu = getTitleMenuOrders(t);


    return (
        <nav className={css.wrap}>
            <ul className={css.ul}>
                {listTitleMenu.map(({name, linkForRoute}) => (
                    <li key={name}>
                        <NavLink
                            to={`/orders/${linkForRoute.toLowerCase()}`}
                            className={({isActive}) =>
                                `${css.menuItem} ${isActive ? css.active : ''}`
                            }
                        >
                            <span className={css.menuText}>{name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export {TitleMenuOrders};